// extracted by extract-css-chunks-webpack-plugin
module.exports = {"background":"app-pages-bloglist--background","list":"app-pages-bloglist--list","spinner":"app-pages-bloglist--spinner"};